import tmhRequest from '@/config/tmhRequest'

export default {
  searchCustomerNursingLog: function (data) {
    return tmhRequest({
      url: '/customer/customernursinglog/searchcustomernursinglog',
      method: 'post',
      params: data,
    })
  },

  searchListCustomerNursingLog: function (data) {
    return tmhRequest({
      url: '/customer/customernursinglog/searchcustomernursinglog',
      method: 'post',
      params: data,
    })
  },

  searchCustomerNursingLogCount: function (data) {
    return tmhRequest({
      url: '/customer/customernursinglog/searchcustomernursinglogcount',
      method: 'post',
      params: data,
    })
  },

  searchCustomerNursingLogByPage: function (data) {
    return tmhRequest({
      url: '/customer/customernursinglog/searchcustomernursinglogbypage',
      method: 'post',
      params: data,
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/customer/customernursinglog.js